<div class="container">
    <div mat-dialog-content>
        <p class="heading">Reordering of images is possible only in list view</p>
        <p>Do you want to switch to list view?</p>
      </div>
      <div class="buttons">
        <button mat-button class="yes-button" (click)="onYesClick()">Yes</button>
        <button mat-button class="no-button" (click)="onNoClick()">No</button>
      </div>
</div>

